export default "__VITE_ASSET__Cb2svT55__"